var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1C21.1797 1 27 6.8203 27 14C27 21.1797 21.1797 27 14 27C6.8203 27 1 21.1797 1 14C1 6.8203 6.8203 1 14 1Z",
    fill: "#12ABBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1C21.1797 1 27 6.8203 27 14C27 21.1797 21.1797 27 14 27C6.8203 27 1 21.1797 1 14C1 6.8203 6.8203 1 14 1Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2411 8.99111L18.3661 7.86612C18.8543 7.37796 19.6457 7.37796 20.1339 7.86612C20.622 8.35427 20.622 9.14573 20.1339 9.63388L13.0548 16.713C12.7023 17.0654 12.2676 17.3245 11.7899 17.4668L10 18L10.5332 16.2101C10.6755 15.7324 10.9346 15.2977 11.287 14.9452L17.2411 8.99111ZM17.2411 8.99111L19 10.75M18 15.3333V18.5C18 19.3284 17.3284 20 16.5 20H9.5C8.67157 20 8 19.3284 8 18.5V11.5C8 10.6716 8.67157 9.99999 9.5 9.99999H12.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.eab729a4710f4cab3f91c35ef46e7678.svg";
export { ForwardRef as ReactComponent };